import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-edit-subscription-license-category',
  templateUrl: './edit-subscription-license-category.component.html',
  styleUrls: ['./edit-subscription-license-category.component.css']
})
export class EditSubscriptionLicenseCategoryComponent extends BaseComponent implements OnInit {
  customer_id;
  updateCategoryForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  category_id: string;
  selectedCompany: string;
  categoryObj: any;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.updateCategoryForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? '' : this.customer_id, Validators.required],
      category_name: ['', [Validators.required, Validators.maxLength(255)]]
    });
    if (localStorage.getItem('edit_subscription_license_category_id')) {
      this.category_id = localStorage.getItem('edit_subscription_license_category_id');
      this.selectedCompany = localStorage.getItem('edit_subscription_license_category_company_id');
      this.masterService.getLicenseCategoryById(this.selectedCompany, this.category_id).subscribe(response => {
        if (response.status) {
          this.categoryObj = response.data;
          this.dataBinding();
        } else {
          this.toastrService.error(response.message || 'License category not found');
        }
      });
    }
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);
    }, error => {
      console.log(error);
    });
  }
  get f() { return this.updateCategoryForm.controls; }
  dataBinding() {
    this.updateCategoryForm.patchValue({
      selectedCompany: this.selectedCompany,
      category_name: this.categoryObj && this.categoryObj.category_name
    });
  }
  updateCategory() {
    this.submitted = true;
    if (this.updateCategoryForm.invalid) {
      return;
    }
    const { selectedCompany } = this.updateCategoryForm.value;
    this.ngxSpinnerService.show();
    this.masterService.updateLicenseCategory(selectedCompany, this.category_id, this.updateCategoryForm.value).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License category updated successfully');
        this.router.navigateByUrl('/corporate/subscription-license-category-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
